import CryptoJS from "crypto-js";

// Insert html
export const createMarkup = markup => {
  return {
    __html: markup
  };
};

export const encodeHTML = string => {
  const parser = new DOMParser();
  const dom = parser.parseFromString(
    "<!doctype html><body>" + string,
    "text/html"
  );
  const decodedString = dom.body.textContent;
  return decodedString;
};

// For gravity forms security
export function calculateSig(stringToSign, privateKey) {
  const hash = CryptoJS.HmacSHA1(stringToSign, privateKey);
  const base64 = hash.toString(CryptoJS.enc.Base64);
  return encodeURIComponent(base64);
}

//Format date
export function formatDate(date) {
  const dateObject = new Date(date);
  const newDate = dateObject.toLocaleString("en-us", {
    month: "short",
    year: "numeric"
  });
  return newDate;
}

//Google map options
export const createMapOptions = () => {
  return {
    gestureHandling: "cooperative",
    styles: [
      {
        featureType: "administrative",
        elementType: "all",
        stylers: [
          {
            saturation: "-100"
          }
        ]
      },
      {
        featureType: "administrative.province",
        elementType: "all",
        stylers: [
          {
            visibility: "off"
          }
        ]
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [
          {
            saturation: -100
          },
          {
            lightness: 65
          },
          {
            visibility: "on"
          }
        ]
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [
          {
            saturation: -100
          },
          {
            lightness: "50"
          },
          {
            visibility: "simplified"
          }
        ]
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [
          {
            saturation: "-100"
          }
        ]
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [
          {
            visibility: "simplified"
          }
        ]
      },
      {
        featureType: "road.arterial",
        elementType: "all",
        stylers: [
          {
            lightness: "30"
          }
        ]
      },
      {
        featureType: "road.local",
        elementType: "all",
        stylers: [
          {
            lightness: "40"
          }
        ]
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [
          {
            saturation: -100
          },
          {
            visibility: "simplified"
          }
        ]
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [
          {
            hue: "#ffff00"
          },
          {
            lightness: -25
          },
          {
            saturation: -97
          }
        ]
      },
      {
        featureType: "water",
        elementType: "labels",
        stylers: [
          {
            lightness: -25
          },
          {
            saturation: -100
          }
        ]
      }
    ]
  };
};



// WEBPACK FOOTER //
// ./src/helpers/functions.js